import React, { forwardRef, useImperativeHandle, useState, Fragment, useEffect, useRef } from 'react';

const AsideContent = forwardRef(({ children, title, cssClass }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useImperativeHandle(ref, () => ({
        toggleAside() {
            setIsOpen(!isOpen);
        },
        open() {
            setIsOpen(true);
        },
        loading(showLoader) {
            setIsLoading(showLoader);
        }
    }));

    const asideRef = useRef(null);
    const handleClickOutside = (e) => {
        if (asideRef.current && !asideRef.current.contains(e.target) && isOpen) {
            setIsOpen(!isOpen);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);


    return (
        <Fragment>
            {isOpen && (
                <aside className={`aside-content ${cssClass}`} ref={asideRef}>
                    <div className="aside-content__title-container">
                        <h3 className="aside-content__title">{title}</h3>
                        <div className="aside-content__close-button" onClick={() => setIsOpen(false)}></div>
                    </div>
                    <div className="aside-content__body">
                        {children}
                        {/* The loader should be below children so that our users can render some children while loading */}
                        {isLoading && (
                            <div className="aside-content__loader loader"></div>
                        )}
                    </div>
                </aside>
            )}
        </Fragment>
    );
});

export default AsideContent;